import { Box } from "@mui/material";
import { Text } from "@src/appV2/redesign/components/Text";
import { type ReactNode } from "react";

interface Props {
  children: ReactNode;
  showSuccessIndicator?: boolean;
}

/** The single semantic heading used by each redesigned login step. */
export function LoginStepHeading({
  children,
  showSuccessIndicator = false,
}: Props): React.ReactElement {
  return (
    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 2 }}>
      {showSuccessIndicator && (
        <Text
          inline
          aria-hidden
          sx={(theme) => ({ color: theme.palette.primary.main, fontSize: "1.25rem" })}
        >
          ✓
        </Text>
      )}
      <Box
        component="h1"
        sx={(theme) => ({
          ...theme.typography.h5,
          color: theme.palette.base?.base,
          fontWeight: theme.typography.fontWeightBold,
          margin: 0,
          textAlign: "center",
        })}
      >
        {children}
      </Box>
    </Box>
  );
}
